import * as React from "react";
import Styled from "styled-components/macro";
import Image, { GatsbyImageProps } from "gatsby-image";
import Media from "@uizard-io/styled-media-query";
import Headline from "../../texts/Headline";
import Description from "../../texts/Description";
import Button from "../../buttons/Button";
import RichDescription from "../../texts/RichDescription";

import BasicIcon from "../../../assets/icon-basic-card.svg";
import AIIcon from "../../../assets/AI-icon.svg";
import BrandIcon from "../../../assets/Brand-icon.svg";
import BrowserIcon from "../../../assets/Browser-icon.svg";
import ComponentsIcon from "../../../assets/Components-icon.svg";
import ShareIcon from "../../../assets/Share-icon.svg";
import SupportIcon from "../../../assets/Support-icon.svg";
import TeamIcon from "../../../assets/Team-icon.svg";
import TransformIcon from "../../../assets/Transform-icon.svg";
import MagicWandIcon from "../../../assets/Magic-wand-icon.svg";
import AppDesign from "../../../assets/Icon_MobileDesign.svg";
import UXUIIcon from "../../../assets/Icon_UXUI.svg";
import WebDesignIcon from "../../../assets/Icon_WebDesign.svg";

const Icon = Styled.div`
  background-color: ${(props) =>
    !props.dark ? "#E7E7E7" : props.theme.colors.gray.piner};
  border-radius: 1.5rem;
  width: 5rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
`;

const NavButtonLink = Styled.a`
`;

const ExtendedButton = Styled(Button)`
  ${Media.lessThan("medium")`
    margin-bottom: 3rem;
    width: 100%;
  `}
`;

export const ExtendedDescription = Styled(Description)`
`;

export const ExtendedHeadline = Styled(Headline)`
`;

export const ImageA = Styled(Image)`
    height: 100%;
`;

export const BasicCardContainer = Styled.div`
  
    background-color: ${(props) =>
      !props.dark ? props.theme.colors.gray.lighter : "black"};
    padding: ${(props) =>
      !props.centered ? "9rem 0 0 9rem" : "9rem 9rem 0 9rem"};
    border-radius: 2rem;
    overflow: hidden;
    
    ${ExtendedHeadline} {
        color: ${(props) => (!props.dark ? "black" : "white")}
    }
    
    ${Description} {
        color: ${(props) => (!props.dark ? "black" : "white")}
    }


    ${Media.lessThan("1024px")`
        padding: ${(props) =>
          !props.centered ? "3rem 0 0 3rem" : "3rem 3rem 0 3rem"};
    `} 

    ${Media.lessThan("medium")`
        ${(props) =>
          props.widthLeftCard === "100%" &&
          !props.noCenter &&
          `
            padding: ${(props) =>
              !props.centered ? "6rem 0 0 6rem" : "9rem 6rem 0 6rem"};
        `}
    `}

    ${Media.lessThan("small")`
     ${(props) =>
       props.widthLeftCard === "100%" &&
       !props.noCenter &&
       `
          padding: ${(props) =>
            !props.centered ? "3rem 0 0 3rem" : "3rem 0 0 3rem"};
        `}
    `}
`;

export const ImageWrapper = Styled.div`
    background-color: ${(props) =>
      props.image.imageA ? "transparent" : "#D8D8D8"};
    width: 100%;
    ${Media.lessThan("medium")`
        height: ${(props) => props.image.heightMob}; 
    `} 
`;

export type BasicCardProps = {
  headline: string;
  description: string;
  image?: {
    heightDesktop: string;
    heightMob: string;
    imageA: GatsbyImageProps;
  };
  dark?: boolean;
  centered?: boolean;
  icon?: string;
  cta?: string;
  ctalink?: string;
};

const BasicCard = ({
  headline,
  description,
  image,
  dark,
  centered,
  icon,
  cta,
  ctalink
}: BasicCardProps) => (
  <BasicCardContainer dark={dark} centered={centered} image={false}>
    <Icon dark={dark}>
      {icon == "ai" ? (
        <AIIcon />
      ) : icon == "brand" ? (
        <BrandIcon />
      ) : icon == "browser" ? (
        <BrowserIcon />
      ) : icon == "component" ? (
        <ComponentsIcon />
      ) : icon == "share" ? (
        <ShareIcon />
      ) : icon == "support" ? (
        <SupportIcon />
      ) : icon == "team" ? (
        <TeamIcon />
      ) : icon == "transform" ? (
        <TransformIcon />
      ) : icon == "magic" ? (
        <MagicWandIcon />
      ): icon == "appdesign" ? (
        <AppDesign />
      ): icon == "uxui" ? (
        <UXUIIcon />
      ):icon == "webdesign" ? (
        <WebDesignIcon />
      ):(
        <BasicIcon />
      )}
    </Icon>
    <ExtendedHeadline>{headline}</ExtendedHeadline>
    
    {description.indexOf("<a:") > -1 ? <RichDescription dark = {dark} content = {description}/> : <ExtendedDescription>{description}</ExtendedDescription>}
    {image && (
      <ImageWrapper image={image}>
        {/* eslint-disable-next-line no-nested-ternary */}
        <ImageA
          fluid={
            image.imageA
              ? "fluid" in image.imageA
                ? image.imageA.fluid
                : null
              : null
          }
          alt={"Image showcasing Uizard's capability to " + headline}
        />
      </ImageWrapper>
    )}
    {cta && ctalink && (
      <NavButtonLink href={ctalink}>
        <ExtendedButton solid>{cta}</ExtendedButton>
      </NavButtonLink>
    )}
  </BasicCardContainer>
);

export default BasicCard;

BasicCard.defaultProps = {
  image: null,
  dark: false,
};
